import { Label, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IRecommendationPriceDiscountProps {
  oldPrice: string;
  percent: string;
}

export const RecommendationPriceDiscount: React.FC<IRecommendationPriceDiscountProps> = ({ oldPrice, percent }) => {
  return (
    <span className={styles['price-discount']} data-testid="price-discount">
      <Label background="accent-positive-primary" color="text-inverted-default">
        {percent}
      </Label>
      <div className={styles['old-price']}>
        <UIText2 color="text-secondary-default">{oldPrice}</UIText2>
      </div>
    </span>
  );
};
